var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btnparent"},[_c('router-link',{staticClass:"loginbtn",attrs:{"to":"/home"}},[_vm._v(_vm._s(_vm.btntext))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }